import React from "react";

export default function Tokenomics() {
  return (
    <div className="tokenomics" id="tokenomics">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <h1>Tokenomics</h1>
          </div>
        </div>

        <div className="row ">
          <div className="col-4 col-md-2 bg-blue text-center">
            <h5>Buy</h5>
          </div>
          <div className="col-8 col-md-8 bg-blue">
            <div className="row">
              <div className="col-md-3">
                <h6>
                  <span>10%</span> - Buy
                </h6>
              </div>
              <div className="col-md-3 ">
                <h6>
                  <span>4%</span> - Marketing
                </h6>
              </div>
              <div className="col-md-3">
                <h6>
                  <span> 2%</span> - Dev
                </h6>
              </div>
              <div className="col-md-3">
                <h6>
                  <span>10% </span> - LP
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-0 col-md-2"></div>
          <div className="col-4 col-md-2 bg-blue text-center">
            <h5>Sell</h5>
          </div>
          <div className="col-8 col-md-8 bg-blue">
            <div className="row">
              <div className="col-md-3">
                <h6>
                  <span> 15%</span> - Sell
                </h6>
              </div>
              <div className="col-md-3">
                <h6>
                  <span>6%</span> - Marketing
                </h6>
              </div>
              <div className="col-md-3">
                <h6>
                  <span> 2%</span> - Dev
                </h6>
              </div>
              <div className="col-md-3">
                <h6>
                  <span>10%</span> - LP
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4 col-md-2 bg-blue text-center">
            <h5>Allo</h5>
          </div>
          <div className="col-8 col-md-8 bg-blue">
            <div className="row">
              <div className="col-md-4 ">
                <h6>
                  <span> 75%</span> - Liquidity
                </h6>
              </div>
              <div className="col-md-4">
                <h6>
                  <span>5%</span> - Team{" "}
                </h6>
              </div>
              <div className="col-md-4">
                <h6>
                  <span>20% </span> - Stake2Earn
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
